import type { ModalsRenderFunction } from '@wix/da-shared-react/pkg/Modals/DaModal';
import { DreamupFormModals } from '../../constants';
import PromptGuidelinesModal from './PromptGuidelinesModal';
import PointsModal from './PointsModal';

export const modalsRenderFunc: ModalsRenderFunction = (modalType, popModal, params) => {
  switch (modalType) {
    case DreamupFormModals.POINTS:
      return <PointsModal onRequestClose={popModal} />;
    case DreamupFormModals.PROMPT_GUIDELINES:
      return <PromptGuidelinesModal onRequestClose={popModal} onConfirm={params.onConfirm} />;
    default:
      return null;
  }
};
